<template>
  <b-container
    class="modules-view-panel px-0"
    :class="mainClassModifier"
    fluid>
    <template v-if="isGrid">
      <grid-item
        v-for="assetModule in modules"
        :class="itemClass"
        :key="assetModule.id"
        :asset-module="assetModule"
      />
    </template>
    <template v-else>
      <list-item
        v-for="assetModule in modules"
        :class="itemClass"
        :key="assetModule.id"
        :asset-module="assetModule"
      />
    </template>
  </b-container>
</template>

<script>
import { alertModes } from '@/services/messages/alertService';
import GridItem from './GridItem';
import ListItem from './ListItem';

export default {
  props: {
    modules: Array,
    viewMode: {
      type: String,
      required: false,
      default: 'grid',
    },
  },
  components: {
    GridItem,
    ListItem,
  },
  computed: {
    itemClass() {
      return `modules-view-panel__item_${this.viewMode}`;
    },
    mainClassModifier() {
      return `modules-view-panel_${this.viewMode}`;
    },
    isGrid() {
      return this.viewMode === 'grid';
    },
    isList() {
      return this.viewMode === 'list';
    },
  },
  methods: {
    pushCopiedToast() {
      this.$pushAlert({
        message: 'general.copied-to-clipboard',
        mode: alertModes.TOAST,
        type: 'success',
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/components/badge-default-colors.sass"
  @import "src/styles/defaults/mobile-first"

  .modules-view-panel
    &_grid
      text-align: center
      display: grid
      grid-template-columns: repeat(3, 1fr)
      grid-column-gap: 20px
      +media-max-md()
        grid-template-columns: repeat(2, 1fr)
      +media-xs()
        grid-template-columns: repeat(1, 1fr)
    &__last-reading-label
      display: block
      margin-bottom: 0
    &__last-reading,
    &__self-diagnosis
      color: var(--font-color-primary)
    &__self-diagnosis-icon
      color: var(--font-color-primary)

</style>
